import { useQuery } from "@tanstack/react-query";
import api from "../../http";

export const useGetDefensiveById = (id: string, enabled = true) => {
    return useQuery({
        queryKey: ['defensive', id],
        queryFn: async () => (await api.get(`/agricultural-defensives/findOne/${id}`)).data,
        enabled: !!id && enabled,
    });
};